export default __webpack_public_path__ + "static/media/flag-moldova.c14d407d.svg";